import {notification} from 'antd'
import _ from 'lodash'
import {renderSelf} from 'views/Shared'
import {AppEntities, MaterialTypes, MessageTypes} from './enums'

export const organizationMessages = {
    [MessageTypes.ERROR]: 'error',
    [MessageTypes.EMPTY]: 'organization not found',
}

export const userMessages = {
    [MessageTypes.ERROR]: 'error',
    [MessageTypes.EMPTY]: 'user not found',
}

export const getMessage = (
    entity,
    type = MessageTypes.ERROR,
    transform = renderSelf
) => {
    const defaultMessage = 'error'

    let message = defaultMessage

    const getMessage = (from) => _.get(from, type, defaultMessage)

    switch (entity) {
        case AppEntities.ORGANIZATION:
            message = getMessage(organizationMessages)
            break
        case AppEntities.USER:
            message = getMessage(userMessages)
            break
        default:
            break
    }
    return transform(message)
}

export const showNotification = ({
                                     message,
                                     description,
                                     type = MaterialTypes.INFO,
                                     duration,
                                     ...rest
                                 }) =>
    notification[type]({
        message,
        description,
        ...(duration !== undefined ? {duration} : {}),
        ...rest,
    })

export const getValidationMessage = ({
                                         type,
                                         notValid = true,
                                         translate = renderSelf,
                                     }) => {
    let message = 'required field'
    switch (type) {
        case 'email':
            message = notValid ? 'email is not valid' : 'email is required'
            break
        default:
            break
    }
    return translate(message)
}
